import { Button } from "materials/button/menus/model"
export class shareEmptyLayout {
  constructor(difference) {
    this.createBlockTimes = 0
    this.styleName = "1"
    this.innerElement = "layoutComponent"
    this.thumbnail = require("../../assets/images/leftMenu/layout/layout_1.png")
    this.width = 320
    this.height = 150
    this.top = 460
    this.left = 35
    this.moduleId = ""
    this.appId = ""
    this.isCache = true
    this.isShowTabs = false
    this.isShowTitle = false
    this.isShowMoreBtn = false
    this.disableSetColAndRow = true
    this.disableCancleGroup = true
    this.activeIndex = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.boxShadowColor = "rgba(96,100,106,1)"
    this.boxShadowH = 0
    this.boxShadowV = 0
    this.boxShadowBlur = 0
    this.boxShadowSpread = 0
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.imgSrc = ""
    this.opacity = 100
    this.noCacheComponent = false
    this.updateTimer = 100
    this.reverseGetColsUid = false
    this.titleOptions = [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ]
    this.rows = [
      {
        height: "100%",
        alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
        cols: [
          //width加起来不能大于12
          {
            uid: "emptyLayoutComponentRootBox",
            alignSelf: "stretch",
            width: "100%",
            component: null,
            disableSetColAndRow: true,
            disableSetData: true,
            displayFlex: true,
            elementOptions: [
              new Button( {
                width: 150,
                height: 50,
                top: 10,
                left: 10,
                draggable: false,
                specialClassName: "replayAnimate",
                elementInLayoutId: 0,
                innerElement: "cxButton",
                content: "重播",
                openBlankPage: true,
                linkUrl: "",
                accessRulers: [],
                fontFamily: "sans-serif",
                fontSize: 14,
                lineHeight: 14,
                fontWeight: 600,
                bgColor: "#C05017",
                clipSize: "cover",
                repeatType: "no-repeat",
                alignType: "center center",
                imgSrc: "http://146394rh.mh.chaoxing.com/engine/upload/engine/2021-04/20210407152144481e.jpg",
                color: "rgba(255,255,255,1)",
                textIsThemeColor: false,
                bgType: "自定义",
                bgColorIsThemeColor: false,
                letterSpacing: 0,
                fontStyle: "normal",
                rotate: 0,
                textDecoration: "none",
                textAlign: "left",
                writingMode: "horizontal-tb",
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                borderBottomLeftRadius: 12,
                borderBottomRightRadius: 12,
                borderColor: "#C05017",
                borderWidth: 1,
                borderStyle: "solid", // solid, dashed, dotted
                borderIsThemeColor: false,
                boxShadowColor: ["#C05017"],
                boxShadowH: [0],
                boxShadowV: [0],
                boxShadowBlur: [0],
                boxShadowSpread: [0],
                iconPosition: "left", // left,right
                iconSrc: "",
                iconType: "img", // img,icon 图片和字体图标
                iconWidth: 14,
                iconMargin: 10,
                iconColorIsThemeColor: false,
                iconColor: "#e9e9e9",
                opacity: 100,
                background: []
              }),

              // 产品需求，现在的分享都已经用到了微信里的分享，该功能废弃
              // new Button({
              //   width: 150,
              //   height: 50,
              //   top: 10,
              //   left: 120,
              //   draggable: false,
              //   specialClassName: "createMyPage",
              //   elementInLayoutId: 1,
              //   innerElement: "cxButton",
              //   content: "生成我的报告",
              //   openBlankPage: true,
              //   linkUrl: "",
              //   accessRulers: [],
              //   fontFamily: "sans-serif",
              //   fontSize: 14,
              //   lineHeight: 14,
              //   fontWeight: 600,
              //   bgColor: "#333333",
              //   clipSize: "cover",
              //   repeatType: "no-repeat",
              //   alignType: "center center",
              //   imgSrc: "http://146394rh.mh.chaoxing.com/engine/upload/engine/2021-04/20210407152144481e.jpg",
              //   color: "rgba(255,255,255,1)",
              //   textIsThemeColor: false,
              //   bgType: "自定义",
              //   bgColorIsThemeColor: false,
              //   letterSpacing: 0,
              //   fontStyle: "normal",
              //   rotate: 0,
              //   textDecoration: "none",
              //   textAlign: "left",
              //   writingMode: "horizontal-tb",
              //   borderTopLeftRadius: 12,
              //   borderTopRightRadius: 12,
              //   borderBottomLeftRadius: 12,
              //   borderBottomRightRadius: 12,
              //   borderColor: "#333333",
              //   borderWidth: 1,
              //   borderStyle: "solid", // solid, dashed, dotted
              //   borderIsThemeColor: false,
              //   boxShadowColor: ["#333333"],
              //   boxShadowH: [0],
              //   boxShadowV: [0],
              //   boxShadowBlur: [0],
              //   boxShadowSpread: [0],
              //   iconPosition: "left", // left,right
              //   iconSrc: "",
              //   iconType: "img", // img,icon 图片和字体图标
              //   iconWidth: 14,
              //   iconMargin: 10,
              //   iconColorIsThemeColor: false,
              //   iconColor: "#e9e9e9",
              //   opacity: 100,
              //   background: []
              // }),
              // 目前导出pdf功能已经交给其他团队来处理，如果后续需要则作为需求，和三方团队对接功能
              // 预览页改造插件文件 exportPdfPlugin
              // new Button({
              //   width: 150,
              //   height: 50,
              //   top: 10,
              //   left: 120,
              //   draggable: false,
              //   specialClassName: "exportPdf",
              //   elementInLayoutId: 2,
              //   innerElement: "cxButton",
              //   content: "导出pdf",
              //   openBlankPage: true,
              //   linkUrl: "",
              //   accessRulers: [],
              //   fontFamily: "sans-serif",
              //   fontSize: 14,
              //   lineHeight: 14,
              //   fontWeight: 600,
              //   bgColor: "#333333",
              //   clipSize: "cover",
              //   repeatType: "no-repeat",
              //   alignType: "center center",
              //   imgSrc: "http://146394rh.mh.chaoxing.com/engine/upload/engine/2021-04/20210407152144481e.jpg",
              //   color: "rgba(255,255,255,1)",
              //   textIsThemeColor: false,
              //   bgType: "自定义",
              //   bgColorIsThemeColor: false,
              //   letterSpacing: 0,
              //   fontStyle: "normal",
              //   rotate: 0,
              //   textDecoration: "none",
              //   textAlign: "left",
              //   writingMode: "horizontal-tb",
              //   borderTopLeftRadius: 12,
              //   borderTopRightRadius: 12,
              //   borderBottomLeftRadius: 12,
              //   borderBottomRightRadius: 12,
              //   borderColor: "#333333",
              //   borderWidth: 1,
              //   borderStyle: "solid", // solid, dashed, dotted
              //   borderIsThemeColor: false,
              //   boxShadowColor: ["#333333"],
              //   boxShadowH: [0],
              //   boxShadowV: [0],
              //   boxShadowBlur: [0],
              //   boxShadowSpread: [0],
              //   iconPosition: "left", // left,right
              //   iconSrc: "",
              //   iconType: "img", // img,icon 图片和字体图标
              //   iconWidth: 14,
              //   iconMargin: 10,
              //   iconColorIsThemeColor: false,
              //   iconColor: "#e9e9e9",
              //   opacity: 100,
              //   background: []
              // }),
              new Button({
                width: 150,
                height: 50,
                top: 60,
                left: 10,
                draggable: false,
                specialClassName: "sharePage",
                hideOutApp: true,
                elementInLayoutId: 3,
                innerElement: "cxButton",
                content: "转发",
                openBlankPage: true,
                linkUrl: "",
                accessRulers: [],
                fontFamily: "sans-serif",
                fontSize: 14,
                lineHeight: 14,
                fontWeight: 600,
                bgColor: "#333333",
                clipSize: "cover",
                repeatType: "no-repeat",
                alignType: "center center",
                imgSrc: "http://146394rh.mh.chaoxing.com/engine/upload/engine/2021-04/20210407152144481e.jpg",
                color: "rgba(255,255,255,1)",
                textIsThemeColor: false,
                bgType: "自定义",
                bgColorIsThemeColor: false,
                letterSpacing: 0,
                fontStyle: "normal",
                rotate: 0,
                textDecoration: "none",
                textAlign: "left",
                writingMode: "horizontal-tb",
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                borderBottomLeftRadius: 12,
                borderBottomRightRadius: 12,
                borderColor: "#333333",
                borderWidth: 1,
                borderStyle: "solid", // solid, dashed, dotted
                borderIsThemeColor: false,
                boxShadowColor: ["#333333"],
                boxShadowH: [0],
                boxShadowV: [0],
                boxShadowBlur: [0],
                boxShadowSpread: [0],
                iconPosition: "left", // left,right
                iconSrc: "",
                iconType: "img", // img,icon 图片和字体图标
                iconWidth: 14,
                iconMargin: 10,
                iconColorIsThemeColor: false,
                iconColor: "#e9e9e9",
                opacity: 100,
                background: []
              })
            ],
            componentBoxOptions: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
              borderStyle: "dashed", // solid, dashed, dotted
              borderColor: "rgba(96,100,106,1)",
              borderWidth: 1,
              clipSize: "cover",
              repeatType: "no-repeat",
              alignType: "center center",
              imgSrc: "",
              opacity: 100
            }
          }
        ]
      }
    ]
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
